import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  deleteObj,
  getClientPage,
} from '@/api/tracksintegrityanalysisserv'

export default {
  state: {
    state_TracksIntegrityAnalysis_GetAllResult: null,
    state_TracksIntegrityAnalysis_SearchByNameResult: null,
    state_TracksIntegrityAnalysis_GetPageResult: null,
    state_TracksIntegrityAnalysis_GetDetailResult: null,
    state_TracksIntegrityAnalysis_DeleteObjResult: null,
    state_TracksIntegrityAnalysis_GetClientPageResult: null,
  },
  mutations: {
    SET_TRACKSINTEGRITYANALYSIS_GETALL_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysis_GetAllResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSIS_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysis_SearchByNameResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSIS_GETPAGE_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysis_GetPageResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSIS_GETDETAIL_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysis_GetDetailResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSIS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysis_DeleteObjResult = rst;
    },
    SET_TRACKSINTEGRITYANALYSIS_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_TracksIntegrityAnalysis_GetClientPageResult = rst;
    },
  },
  actions: {
    TracksIntegrityAnalysisServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSIS_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSIS_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSIS_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSIS_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TracksIntegrityAnalysisServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRACKSINTEGRITYANALYSIS_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_TracksIntegrityAnalysis_GetAllResult: state => {
      return state.state_TracksIntegrityAnalysis_GetAllResult;
    },
    get_TracksIntegrityAnalysis_SearchByNameResult: state => {
      return state.state_TracksIntegrityAnalysis_SearchByNameResult;
    },
    get_TracksIntegrityAnalysis_GetPageResult: state => {
      return state.state_TracksIntegrityAnalysis_GetPageResult;
    },
    get_TracksIntegrityAnalysis_GetDetailResult: state => {
      return state.state_TracksIntegrityAnalysis_GetDetailResult;
    },
    get_TracksIntegrityAnalysis_DeleteObjResult: state => {
      return state.state_TracksIntegrityAnalysis_DeleteObjResult;
    },
    get_TracksIntegrityAnalysis_GetClientPageResult: state => {
      return state.state_TracksIntegrityAnalysis_GetClientPageResult;
    },
  }
}